import { render } from "./GuarantorInsurance.vue?vue&type=template&id=171b2190"
import script from "./GuarantorInsurance.vue?vue&type=script&lang=js"
export * from "./GuarantorInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/billingInfo/forms/GuarantorInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "171b2190"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('171b2190', __exports__)) {
    console.log('reload')
    api.reload('171b2190', __exports__)
  }
  
  module.hot.accept("./GuarantorInsurance.vue?vue&type=template&id=171b2190", () => {
    console.log('re-render')
    api.rerender('171b2190', render)
  })

}


export default __exports__